import { PayloadAction } from '../../../store.model';
import { filterRows } from '../function/filter-rows.function';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { ToggleFilterCategory } from './toggle-filter-category.action';

export function toggleFilterCategoryReducer(
    state: MainState,
    action: PayloadAction<
        ActionType.MI2_MAIN__TOGGLE_FILTER_CATEGORY,
        ToggleFilterCategory
    >,
): MainState {
    try {
        const nextItems = [...state.improvementGroupFilterItems];

        // if all are selected, deselect all. otherwise select all
        const nextIsNotSelected = nextItems
            .filter(
                (e) =>
                    e.item.scorecardImprovementCategoryId ===
                    action.payload.categoryId,
            )
            .every((e) => e.selected);

        nextItems.forEach((e, ei) => {
            if (
                e.item.scorecardImprovementCategoryId !==
                action.payload.categoryId
            ) {
                return;
            }
            nextItems[ei] = { ...e, selected: !nextIsNotSelected };
        });

        const nextFilteredDirectReports = filterRows({
            rows: state.rows,
            sortOptions: state.sortOptions,
            currentPerformanceClassFilterItems:
                state.currentPerformanceClassFilterItems,
            previousPerformanceClassFilterItems:
                state.previousPerformanceClassFilterItems,
            improvementGroupFilterItems: nextItems,
        });

        return {
            ...state,
            filteredRows: nextFilteredDirectReports,
            improvementGroupFilterItems: nextItems,
        };
    } catch {
        return {
            ...state,
        };
    }
}
